export enum accessorialsPricingType {
  Percentage = "Percentage",
  Fixed = "Fixed"
}
